module.exports = __webpack_public_path__ + "static/imaware-logo-bw-5c1659dff5be904cfcf20f6febff9cf3.svg";